import {
    getRequest,
    handleResponse,
    handleErrorResponse,
} from '../_helpers';
import config from "../_helpers/config";

export const getInitRouteInfo = () => {
    const match = window.location.href.match('(partners\\/(\\w+)(?!:\\/)(\\?section=[\\w\\-]+)?)(&.+)?$')
    const partner = match && match.length > 2 ? match[2] : null
    const query =  match && match.length > 3 ? match[3] : null

    return {
        isInitRoute: !!match,
        partner,
        query
    }
}

export const getRouteInfo = () => {
    const match = window.location.href.match('partners\\/(\\w+)(?!:\\/)')
    const partner = match && match.length > 1 ? match[1] : null

    return {
        isPartnerRoute: !!match,
        partner,
    }
}

const getAuthURI = (partner) => {

    if (!partner) {
        const receivedParams = `partner: ${partner}`;
        throw new Error(`All params are required. Received: ${receivedParams}`);
    }

    return getRequest(`/v1/partners/${partner}/auth`)
        .then(handleResponse, handleErrorResponse);

}

const redirectToAuth = (partner, query) => {
    const baseUrl = config.get('apiUrl');
    return `${baseUrl}/ws/v1/partners/${partner}/auth${query}`;
}

const getPartners = () => {
    return getRequest('/v1/partners')
    .then(handleResponse, handleErrorResponse);
}

export const partnersService = {
    getAuthURI,
    redirectToAuth,
    getPartners,
};
